export default __webpack_public_path__ + "static/media/report-mob.44dd4976.png";